import { render, staticRenderFns } from "./DataGridColumnSelector.vue?vue&type=template&id=ccf7b706&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./DataGridColumnSelector.vue?vue&type=script&lang=js&"
export * from "./DataGridColumnSelector.vue?vue&type=script&lang=js&"
import style0 from "./DataGridColumnSelector.vue?vue&type=style&index=0&id=ccf7b706&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf7b706",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VCombobox,VIcon,VMenu})
